angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobMappings', [
  'acme.common.service.utils',
  'acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.change'
])
.directive('importExportJobMappings', importExportJobMappings)
.controller('ImportExportJobMappingsController', ImportExportJobMappingsController);

function importExportJobMappings() {
  return {
    restrict: 'A',
    replace: true,
    controller: 'ImportExportJobMappingsController',
    controllerAs: '$ctrl',
    scope: {},
    templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappings.tpl.html',
    bindToController: {}
  };
}

/**
 * Controller responsible for managing Mappings for a Job
 * @class ImportExportJobMappingsController
 * @constructor
 * @param $scope
 * @param $state
 * @param $uibModal
 * @param {Object} UtilsService - utilities function helpers
 * @param PermissionsService
 * @param ImportJobsApiService
 * @return {ImportExportJobMappingsController} - Class instance
 */
function ImportExportJobMappingsController(
  $scope,
  $state,
  $uibModal,
  UtilsService,
  PermissionsService,
  ImportJobsApiService
) {
  Object.assign(this, {
    $scope: $scope,
    $uibModal: $uibModal,
    $state: $state,
    UtilsService: UtilsService,
    PermissionsService: PermissionsService,
    ImportJobsApiService: ImportJobsApiService
  });
}

/**
 * Angular lifecycle method $onInit
 * Ran when bindings are ready
 * @public
 * @memberOf ImportExportJobMappingsController
 * @return {Undefined} -
 */
ImportExportJobMappingsController.prototype.$onInit = function () {
  var self = this;

  self.loading = false;
  self.jobId = this.$state.params.id;
  self.paginationOptions = {
    pageNumber: 0,
    pageSize: 10,
    sort: null
  };

  self.vm = {
    gridOptions: {
      enableSorting: false,
      paginationPageSizes: [],
      paginationPageSize: self.paginationOptions.pageSize,
      paginationPageNumber: self.paginationOptions.pageNumber,
      columnDefs: self._getColumns(),
      data: []
    }
  };

  self.vm.gridOptions.appScopeProvider = self;

  self._load(self.jobId);

  self.$scope.$on('ImportExport::mappingsRefresh', function(){
    self._load(self.jobId);
  });
};

ImportExportJobMappingsController.prototype._load = function (jobId) {
  var self = this;

  this.ImportJobsApiService.getMappings(jobId)
    .then(function (response) {
      self.vm.gridOptions.data = response.data;
      self.vm.gridOptions.totalItems = response.data.length;
    });
};

ImportExportJobMappingsController.prototype.openMappingModal = function (mode, mapping) {
  var self = this;

  var modal = this.$uibModal.open({
    templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/ImportExportJobMappingsModal.tpl.html',
    controller: 'ImportExportJobMappingsModalController',
    controllerAs: '$ctrl',
    resolve: {
      job: function () {
        return self.ImportJobsApiService.get(self.jobId)
          .then(function (response) {
            return response.data;
          });
      },
      mode: function () {
        return mode;
      },
      mappings: function () {
        return self.vm.gridOptions.data;
      },
      mapping: function () {
        return mapping;
      }
    }
  });
};

ImportExportJobMappingsController.prototype._getColumns = function () {
  var columns = [
    {
      field: 'view',
      displayName: 'View',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsActionsView.tpl.html'
    },
    {
      field: 'tableType',
      displayName: 'Table Type'
    },
    {
      field: 'fieldFrom',
      displayName: 'From',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsView.tpl.html'
    },
    {
      field: 'fieldTo',
      displayName: 'To',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsView.tpl.html'
    },
    {
      field: 'fieldExpression',
      displayName: 'Expression',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsView.tpl.html'
    },
    {
      field: 'sequence',
      displayName: 'Sequence'
    }
  ];

  if (this.PermissionsService.check('IMPEX_MAPPINGS_UPDATE')) {
    columns.push({
      field: 'edit',
      displayName: 'Edit',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsActionsEdit.tpl.html'
    },{
      field: 'delete',
      displayName: 'Delete',
      cellTemplate: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/importExportJobMappingsActionsDelete.tpl.html'
    });
  }

  return columns;
};

ImportExportJobMappingsController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  'UtilsService',
  'PermissionsService',
  'ImportJobsApiService'
];
